import { render, staticRenderFns } from "./related_customers_list.vue?vue&type=template&id=a0b750de&scoped=true&"
import script from "./related_customers_list.vue?vue&type=script&lang=js&"
export * from "./related_customers_list.vue?vue&type=script&lang=js&"
import style0 from "./related_customers_list.vue?vue&type=style&index=0&id=a0b750de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b750de",
  null
  
)

export default component.exports